export default __webpack_public_path__ + "static/media/copy.744c51fd.svg";